import React, { useState } from 'react';
import { Search, X } from 'lucide-react';

// The magnifier inside a search box. While the box holds text, hovering turns it into an X that
// clears the search term only — column filters have their own FilterX control and are left alone.
const SearchClearIcon = ({ searchTerm, onClear, size = 16 }) => {
  const [hovered, setHovered] = useState(false);
  const showX = hovered && !!searchTerm;
  return (
    <span
      className={`stui-search-icon${searchTerm ? ' stui-search-icon-clearable' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={showX ? onClear : undefined}
      title={showX ? 'Clear search' : undefined}
    >
      {showX ? <X size={size} /> : <Search size={size} />}
    </span>
  );
};

export default SearchClearIcon;
